import styled from 'styled-components';
import TrustSafetyObject from '../../../assets/images/pluvaAutoLanding/trust_object.jpg';
import InnovationMark from '../../../assets/images/pluvaAutoLanding/trust_mark_inno.png';
import DutyMark from '../../../assets/images/pluvaAutoLanding/trust_mark_duty.png';
import { PointBadge } from './PointBadge';

const certificationMarks: { src: string; name: string }[] = [
  {
    src: InnovationMark,
    name: '조달청\n혁신제품인증',
  },
  {
    src: DutyMark,
    name: '생산물\n배상책임보험',
  },
];

export const TrustSafetySection = () => {
  return (
    <Container>
      <TrustSafetyCard>
        <TitleSection>
          <PointBadge title={'인증과 보험'} />
          <Title>{'국가 혁신기술인증은 물론\n생산물 책임보험까지!'}</Title>
          <TitleSectionImage src={TrustSafetyObject} />
          <TitleHelperText>{'조달청에서 발급한 혁신기술인증과\n삼성화재 생산물 책임보험까지 든든하게'}</TitleHelperText>
          <Warning>
            <WarningText>{'제품 결함으로 인한 사고시\n최대 13억 보상'}</WarningText>
          </Warning>
        </TitleSection>
        <CertificationMarks>
          {certificationMarks.map((item) => {
            return (
              <CertificationMark key={item.name}>
                <MarkImage src={item.src} />
                <MarkName>{item.name}</MarkName>
              </CertificationMark>
            );
          })}
        </CertificationMarks>
      </TrustSafetyCard>
    </Container>
  );
};

const Container = styled.div`
  display: flex;
  padding: 0px 24px 48px 24px;
  flex-direction: column;
  justify-content: center;
  align-items: flex-start;
  gap: 32px;
  align-self: stretch;

  border-bottom: 1px solid var(--Light-Scheme-Monochrome-grey20, #e4e4ed);
`;

const TrustSafetyCard = styled.div`
  display: flex;
  padding: 48px 24px;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  gap: 32px;
  align-self: stretch;

  border-radius: var(--radius-medium, 8px);
  background: var(--Light-Scheme-Monochrome-grey10, #f2f2f7);
`;

const TitleSection = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  gap: var(--radius-large, 16px);
  align-self: stretch;

  white-space: pre-line;
`;

const Title = styled.h2`
  color: var(--Light-Scheme-Monochrome-black, #232429);
  text-align: center;

  /* Display/XXX-Large/xxxl-bold */
  font-family: Pretendard;
  font-size: 24px;
  font-style: normal;
  font-weight: 700;
  line-height: 130%; /* 31.2px */
`;

const TitleSectionImage = styled.img`
  width: 180px;
`;

const TitleHelperText = styled.p`
  color: var(--Light-Scheme-Monochrome-black, #232429);
  text-align: center;

  /* Display/Large/l-regular */
  font-family: Pretendard;
  font-size: 16px;
  font-style: normal;
  font-weight: 400;
  line-height: 130%; /* 20.8px */
`;

const Warning = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  gap: var(--radius-small, 4px);
  align-self: stretch;

  white-space: pre-line;
`;

const WarningText = styled.p`
  color: var(--Light-Scheme-Color-primary-green, #34c77e);
  text-align: center;

  /* Display/Large/l-bold */
  font-family: Pretendard;
  font-size: 16px;
  font-style: normal;
  font-weight: 700;
  line-height: 130%; /* 20.8px */
`;

const CertificationMarks = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  gap: var(--radius-large, 16px);
  align-self: stretch;
`;

const CertificationMark = styled.div`
  display: flex;
  padding: 24px 0px;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  gap: var(--radius-medium, 8px);
  flex: 1 0 0;

  border-radius: var(--radius-medium, 8px);
  background: var(--Light-Scheme-Monochrome-white, #fff);
`;

const MarkImage = styled.img`
  width: 90px;
  height: 90px;
`;

const MarkName = styled.p`
  color: var(--Light-Scheme-Monochrome-black, #232429);
  text-align: center;

  /* Display/Medium/m-regular */
  font-family: Pretendard;
  font-size: 14px;
  font-style: normal;
  font-weight: 400;
  line-height: 130%; /* 18.2px */

  white-space: pre-line;
`;
